import BaseElement from './BaseElement'
import { WishlistProductSlideout } from '../components/WishlistProductSlideout'

export default class WishlistProductSlideoutElement extends BaseElement {
  static get observedAttributes () {
    return ['product-id', 'product-handle', 'variant-selected-id', 'template-suffix', 'product-personalised-price', 'open-source', 'data-product']
  }

  renderElement () {
    const productId = parseInt(this.getAttribute('product-id') as string)
    const productHandle = this.getAttribute('product-handle')
    const variantSelectedId = parseInt(this.getAttribute('variant-selected-id') as string)
    const templateSuffix = this.getAttribute('template-suffix') as string
    const productPersonalisedPrice = this.getAttribute('product-personalised-price') && JSON.parse(this.getAttribute('product-personalised-price') as string)
    const openSource = this.getAttribute('open-source') as 'pdp' | 'plp' | 'cart' | null

    this.rootElement.render(
      <WishlistProductSlideout
        productId={productId}
        productHandle={productHandle}
        variantSelectedId={variantSelectedId}
        templateSuffix={templateSuffix}
        productPersonalisedPrice={productPersonalisedPrice}
        openSource={openSource || 'plp'}
      />
    )
  }
}
